Cureus.StatsWidget = {}

//= require_tree ./StatsWidget